import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'label',
    'documentRecordLabel',
    'documentsGrid'
)`
    ${propStyles};
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentRecordLabel.tsx